import { render, staticRenderFns } from "./MainPayments.vue?vue&type=template&id=529bdca4&scoped=true"
import script from "./MainPayments.vue?vue&type=script&lang=js"
export * from "./MainPayments.vue?vue&type=script&lang=js"
import style0 from "./MainPayments.vue?vue&type=style&index=0&id=529bdca4&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529bdca4",
  null
  
)

export default component.exports